import React from "react";
import { ReactNode } from "react";

export interface Heading2Props {
  heading?: ReactNode;
  subHeading?: ReactNode;
  className?: string;
}

const Heading1: React.FC<Heading2Props> = ({
  className = "",
  heading = "Tours Packages",
  subHeading,
}) => {
  return (
    <div className={`mb-0 ${className}`}>
      <h2 className="text-5xl font-semibold">{heading}</h2>
      {subHeading ? (
        subHeading
      ) : (
        <span className="block text-neutral-500 dark:text-neutral-400 mt-3">
          {/* 233 stays
          <span className="mx-2">·</span>
          Aug 12 - 18
          <span className="mx-2">·</span>2 Guests */}
        </span>
      )}
    </div>
  );
};

export default Heading1;
